import React from 'react'
import { Navigate, Outlet} from 'react-router-dom'
import {useSelector} from 'react-redux'

const PublicRoutes = () => {
    const {isAuth} = useSelector(state => state?.login)
    return (
        isAuth?<Navigate to="/dashboard"/>:<Outlet/>
    )
}

export default PublicRoutes;